import React, { useEffect } from 'react'
import './banner.css'
import { useParams } from 'react-router-dom'
import { festiveEventsFacilities } from '../../constants/globalConstants'


function Banner() {

    const {facility} = useParams()
    // const imagesArray = [
    //   {
    //     url: 'https://api.parkengage.com/brand-settings-logo/23'
    //   }
    // ]

    useEffect(() => {
        const carouselElement = document.querySelector('#carouselExampleIndicators')
        if (carouselElement && window.bootstrap) {
            new window.bootstrap.Carousel(carouselElement, {
            interval: 3000,
            ride: 'carousel',
            pause: false,
            })
        }
    }, [])

  return (
    facility == 97967897987889 ? 
    <div className="w-100">
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="3000"
      >
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="3"
            aria-label="Slide 4"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="4"
            aria-label="Slide 5"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="5"
            aria-label="Slide 6"
          ></button>
        </div>

        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="d-block w-100" src="banner/1.png" alt="First slide" />
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src="banner/2.png" alt="Second slide" />
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src="banner/3.png" alt="Third slide" />
          </div>
          <div className="carousel-item active">
            <img className="d-block w-100" src="banner/4.png" alt="First slide" />
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src="banner/5.png" alt="Second slide" />
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src="banner/6.png" alt="Third slide" />
          </div>
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div> : 
    festiveEventsFacilities?.includes(Number(facility)) ? 
      <div className="w-100 d-flex align-items-center justify-content-center"
          style={{ backgroundImage: 'url(banner/festivaloflights.webp)', height: '300px', backgroundPosition: 'center center', backgroundSize: 'cover' }}>
            <span>
              <h1 className='text-white festiveoflights'>RESERVE PARKING NOW</h1>
            </span>
      </div>
    : facility == 164 ? 
    <div className="w-100"
            style={{ backgroundImage: 'url(banner/stadium-baner-top.jpg)', height: '300px', backgroundPosition: 'center center', backgroundSize: 'cover' }}>
    </div>
    :
    <div className="w-100"
            style={{ backgroundImage: 'url(banner/baner-top.jpg)', height: '300px', backgroundPosition: 'center center', backgroundSize: 'cover' }}>
    </div>
  )
}

export default Banner
